﻿'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:DashboardController
 * @description
 * # DashboardController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('DashboardController', ['$routeParams', '$scope', 'ListGrid', 'ListGridStatus', 'DashboardService', 'ListGridConstants', 'FlashService',
    function ($routeParams, $scope, ListGrid, ListGridStatus, DashboadrService, ListGridConstants, FlashService) {
          
          ListGridStatus.gridId = $routeParams.id;

          function loadDashboard() {

              $scope.grid.showGrid = false;

              FlashService.ShowProgressBar();

              DashboadrService.GetPage($routeParams.id).then(function (result) {
                  
                  if (result.success) {
                      $scope.grid.showGrid = true;

                      $scope.pageData = result.data;

                      $scope.pageData.dashboardSections = $scope.pageData.dashboardSections.map(function (item) {
                          item.sectionCluetip = item.sectionCluetip ? JSON.parse(item.sectionCluetip) : null;
                          return item;
                      });

                      $scope.selectDashboard($scope.selectedDashboard || $scope.pageData.dashboardSections[0]);

                      FlashService.HideProgressBar();
                  }
              });
          }

          $scope.selectDashboard = function (dashboard) {

              if (!dashboard || !$scope.grid.showGrid) {
                  return;
              }

              $scope.grid.showGrid = false;

              $scope.selectedDashboard = dashboard;

              DashboadrService.GetDashboard(dashboard.sectionId).then(function (result) {

                  if (result.success) {

                      $scope.grid.gridData = $scope.grid.getGridData($scope, result.data);

                      $scope.globalActions = ListGridStatus.actions.globalActions;

                      setCluetip();

                      $scope.grid.showGrid = true;

                      FlashService.HideProgressBar();
                  }
              });              
          };

          $scope.grid = new ListGrid(ListGridConstants.Types.Dashboard, loadDashboard);
         
          loadDashboard();

          function setCluetip() {
              var dashboard = $scope.pageData.dashboardSections.firstOrDefault(function (item) {
                  return item.sectionId === $scope.selectedDashboard.sectionId;
              });

              dashboard.cluetip = $scope.grid.gridData.cluetip;
          }
  }]);